import React from 'react';
import { useTranslation } from 'react-i18next';
import Style from '../assets/css/patrocinadores.module.css';

const RecentEvents = () => {
    return (
        <section className={Style.recentEvents}>
            <h2 className={Style.eventsTitle}>Eventos recientes</h2>
            
            <div className={Style.eventContainer}>
                <p className={Style.eventIntro}>
                    Una aventura a las afueras de la ciudad de Oaxaca en la localidad de Matatlán, 
                    ha recibido a mixtecnautas 3 días para compartir nuestra pasión por la astronomía. 
                    Los más de 500 visitantes contemplaron una alineación visible de los planetas 
                    en el cielo el 28 de febrero.
                </p>
                
                <div className={Style.eventCards}>
                    {/* Evento 1 */}
                    <div className={Style.eventCard}>
                        <div className={Style.eventImage} style={{ backgroundImage: "url('equipo.webp')" }}></div>
                        <div className={Style.eventDetails}>
                            <h3>Miahuatlán 2025</h3>
                            <p>Oaxaca, México</p>
                            <div className={Style.eventDescription}>
                                Conmemoración de los 50 años del eclipse solar con exposición sobre 
                                exoplanetas y demostración de nuestra aplicación.
                            </div>
                        </div>
                    </div>

                    {/* Evento 2 */}
                    <div className={Style.eventCard}>
                        <div className={Style.eventImage} style={{ backgroundImage: "url('equipo2.webp')" }}></div>
                        <div className={Style.eventDetails}>
                            <h3>Matatlán 2025</h3>
                            <p>Oaxaca, México</p>
                            <div className={Style.eventDescription}>
                                En el marco del festival astronómico anual, nuestro equipo compartió 
                                técnicas de observación planetaria con la comunidad local.
                            </div>
                        </div>
                    </div>
                    
                    {/* Evento 3 */}
                    <div className={Style.eventCard}>
                        <div className={Style.eventImage} style={{ backgroundImage: "url('chekes.webp')" }}></div>
                        <div className={Style.eventDetails}>
                            <h3>Atlixco 2024</h3>
                            <p>Puebla, México</p>
                            <div className={Style.eventDescription}>
                                Participación en la Noche de las Estrellas llevando el conocimiento 
                                de exoplanetas a más de 300 visitantes.
                            </div>
                        </div>
                    </div>
                </div>
                
                {/*<button className={Style.eventsButton}>Ver todos los eventos</button>*/}
            </div>
        </section>
    );
};

export default RecentEvents;